import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconUnlockLine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M8.001 11.333c.734 0 1.334-.6 1.334-1.333S8.735 8.667 8 8.667c-.733 0-1.333.6-1.333 1.333s.6 1.333 1.333 1.333zm4-6h-.666V4C11.335 2.16 9.84.667 8 .667s-3.333 1.16-3.333 3h1.333c0-1.14.86-1.734 2-1.734 1.14 0 2.067.927 2.067 2.067v1.333H4.001c-.733 0-1.333.6-1.333 1.334v6.666c0 .734.6 1.334 1.333 1.334h8c.734 0 1.334-.6 1.334-1.334V6.667c0-.734-.6-1.334-1.334-1.334zm0 8h-8V6.667h8v6.666z"
	})
});
export default SvgIconUnlockLine;
